<template>
  <v-card class="mx-auto mb-10 cards" elevation="0">
    <v-img
      style="border-radius: 20px;"
      class="white--text align-end"
      height="500px"
      :src="require(`../../../../styles/drawable-info/${capa2}`)"
    >
      <v-card-title style="background-color:rgba(0,0,0,0.5);">{{
        title
      }}</v-card-title>
    </v-img>

    <v-card-text style="font-size:18px;" class="text--primary mt-6">
      <div>{{ paragraph }}</div>
    </v-card-text>
    <noticeImages :items="items" :item="item" :description="description" />
  </v-card>
</template>

<script>
export default {
  name: "info",
  components: {
    noticeImages: () => import("../noticeImages/index.vue")
  },
  data() {
    return {
      paragraph: this.$route.query.paragraph,
      title: this.$route.query.title,
      capa2: this.$route.query.capa2,
      items: this.$route.query.images.length,
      item: this.$route.query.images,
      description: this.$route.query.description
    };
  }
};
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  .cards {
    max-width: 100%;
    max-height: 100%;
  }
}
@media only screen and (min-width: 501px) {
  .cards {
    max-width: 60%;
    max-height: 80%;
  }
}
</style>
